// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const YOU_HAVE_BEEN_SUCCESSFULLY_REGISTERED = "Bola si \u00faspe\u0161ne zaregistrovan\u00e1.";
